import React from 'react';
import "./index.scss";
import "./style.scss";
import OfferCarousel from './OfferCarousel';
var CheckoutOffers = function (_a) {
    var offers = _a.offers, getFonts = _a.getFonts;
    return (React.createElement("div", { className: 'checkout-offers' },
        React.createElement("div", { className: 'carousel' },
            React.createElement(OfferCarousel, { offers: offers, getFonts: getFonts }))));
};
export default CheckoutOffers;
